import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import Login from '../pages/auth/LoginPage';
import { useAuthContext } from './useAuthContext';
// routes
import { PATH_PAGE } from '../routes/paths';
import ErrorPage from '../pages/ErrorPage';


// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {

  const { isAuthenticatedWithOAuth, isAuthenticatedOnBackend, isUserConnectedOnRainbow, isSSELinked, isInitialized, isError } = useAuthContext();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (isError) {
    return <Navigate to={PATH_PAGE.errorPage} />;
    // return <ErrorPage />;
  }

  if (!isError && !isInitialized) {
    return <Login />;
  }

  if (!isError  && isAuthenticatedWithOAuth && !isAuthenticatedOnBackend) {
    return <LoadingScreen />;
  }

  if (!isAuthenticatedWithOAuth) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
